/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import React,{memo, useEffect, useRef, useState} from 'react'
import { Pagination, Table ,DatePicker, Space, Select ,Modal, Switch} from 'antd'

import { Button, Checkbox, Form, Input, Radio, Spin} from 'antd'
import dayjs from 'dayjs';
import {ArrowUpOutlined,ArrowDownOutlined } from '@ant-design/icons';
import { Backdrop, Box, ButtonBase, Fade, IconButton, Modal as ModalMui } from '@mui/material';
import { ExclamationCircleFilled } from '@ant-design/icons';
import jwtDecode from 'jwt-decode';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';

import axios from '../apiClient'
import Alert from '../alert'
import moment from 'moment/moment';
import Loader from '../loader';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'white',
  borderRadius: "1rem",
  boxShadow: 24,
  p: 4,
};

const { RangePicker } = DatePicker;
export default function ListOdds() {
    const [matches,setMatches] = useState([])
    const [oddsTotal,setOddsTotal] = useState()
    const [saveOddsLoading,setSaveOddsLoading] = useState(false)
    const [form] = Form.useForm();
    const [matchLang,setMatchLang] = useState("eng")
    const [loading,setLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [date,setDate] = useState({startDate: "",endDate: ""})
    const [leagues,setLeagues] = useState([])
    const [selectedLeague,setSelectedLeague] = useState('');
    const [selectedMatchesToDelete,setSelectedMatchesToDelete] = useState([]);
    const [modalOpen,setModalOpen]  = useState(false);
    const [modalParlayOpen,setParlayModalOpen]  = useState(false);
    const [modalExtraOpen,setExtraModalOpen]  = useState(false);
    const [clickedOddId,setClickedOddId] = useState();
    const [showLastUpdates,setShowLastUpdates] = useState(true);
    const [betUsers,setBetUsers] = useState([]);
    const [matchStatus,setMatchStatus] = useState("all");
    const [forceRerender, setForceRerender] = useState(false);
    const mounted = useRef(false);
    const [storedData,setStoredData] = useState({});
    const changedOdds = useRef([]);
    const ogFormData = useRef();
    const hasMore = useRef(true);
    const fetching = useRef();
    const page = useRef(1);

    useEffect(()=>{
       setDefaultDate();
        const oddLang = JSON.parse(localStorage.getItem("oddLang"));
        if(oddLang && (oddLang == "my" || oddLang == "eng")) setMatchLang(oddLang)

        const showLastUpdates = JSON.parse(localStorage.getItem("showLastUpdatesInListOdd"));
        if(showLastUpdates && (showLastUpdates == true || showLastUpdates == false)) setShowLastUpdates(showLastUpdates)
  
        form.setFieldsValue({data: [{leagueId: null,matches: []}]})
        setTimeout(() => {
          form.getFieldInstance(['data',0,'leagueId'])?.focus()
        }, 100);
    },[])

    const setDefaultDate = () => {
      const startDate = moment().subtract(1,'day').format('YYYY-MM-DD HH:mm:ss');
      const endDate = moment().add(1,'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');
      setDate({startDate,endDate});
    }

    useEffect(()=>{
      if(!mounted.current){
        mounted.current = true;
      }else{
        getOdds()
      }
    },[selectedLeague,date,showLastUpdates])

    useEffect(()=>{
      if(!mounted.current){
        mounted.current = true;
      }else{
        getLeagues();
      }
    },[date])

    const handleCloseAlert = () => setOpenAlert(false)

    const handleOpenAlert =()=> setOpenAlert(true)

    const handleSetMatches = (matches) => setMatches(matches)

    const handleModalClose = () => {
      setModalOpen(false);
    }
    const handleExtraModalClose = () => {
      setExtraModalOpen(false);
    }
    const handleParlayModalClose = () => {
      setParlayModalOpen(false);
    }
    const validataBeforeSave = async(values) =>{
      if(values.matches.length == 0 ) {
        setErrorMsg({ info: true, msg: "Please input first" })
        setOpenAlert(true)
        return 500
      }

      try {
        await form.validateFields();
        return 200
      } catch (error) {
        setErrorMsg({ info: true, msg: "Invalid Format" })
        setOpenAlert(true)
        return 500
      }
        
    }

    const changeFormat = (values) => {
      const copyMatches = JSON.parse(JSON.stringify(values)).matches;
      let returnData = {};

      const matches = [];
      for (let i = 0; i < copyMatches.length; i++) { // loop the matches
        const match = copyMatches[i];
        const hdp = match.hdp;
        const ou = match["o/u"];
        const homeTeamHasHandicap = match.homeTeamHasHandicap;
        if(!hdp || !ou || homeTeamHasHandicap == null) { // delete that index
          continue
        }else{
          const [hdpLeft,hdpSign, hdpRight] = hdp.match(/(\d+|[-+])/g)
          const [ouLeft,ouSign, ouRight] = ou.match(/(\d+|[-+])/g)
          match.bodyHandicapGoal = hdpLeft;
          match.bodyHandicapTeam = homeTeamHasHandicap ? "home_team" : "away_team";
          match.bodyOdd = hdpRight;
          match.bodyOddSign = hdpSign;
          match.ouHandicapGoal = ouLeft;
          match.ouOdd = ouRight;
          match.ouOddSign = ouSign;
          delete match.awayTeam;
          delete match.homeTeam;
          delete match.hdp;
          delete match['o/u'];
          matches.push(match);
        }
      }
      returnData = {matches: matches}
      
      return returnData;
    }

    const handleSave = async (values) =>{
      const formatedData = changeFormat({matches: changedOdds.current});
    
      const code = await validataBeforeSave(formatedData);
      if(code != 200) return;
      setSaveOddsLoading(true)
    
      const token = localStorage.getItem("token");
      const {id: ownerId} = jwtDecode(token);
      let matchesArr = formatedData.matches;
     
      const odds = matchesArr.map((v)=>{
          const {matchId,bodyHandicapGoal,bodyHandicapTeam,bodyOdd,bodyOddSign,ouHandicapGoal,ouOdd,ouOddSign,periods,betType,maxLimit} = v
          return ({
          matchId: matchId,
          popular: v?.popular ? 1 : 0,
          hdp: {
              raw: [
                  bodyHandicapGoal,
                  bodyOddSign+bodyOdd
              ],
              converted: `${bodyHandicapGoal}${bodyOddSign+bodyOdd}`,
              home_team_has_hadicap: bodyHandicapTeam == 'home_team' ? true : false,  
          },
          ou: {
              raw: [
                  ouHandicapGoal,
                  ouOddSign+ouOdd
              ],
              converted: `${ouHandicapGoal}${ouOddSign+ouOdd}`,
              home_team_has_hadicap: bodyHandicapTeam == 'home_team' ? true : false,  
          },
          periods: periods,
          betType: betType,
          maxLimitBetAmount: 0,
          createdBy: ownerId
      })})

      const params = {odds}

      const data = await axios.post(`/bet/setOddByMatchId`, params);
      
      setErrorMsg({ code: data.code, msg: data.message })
      setOpenAlert(true)
      setSaveOddsLoading(false)
      if(data.code == 200) {
        changedOdds.current = [];
        ogFormData.current = values;
        // handleRefresh();
      }
    }

    const onFinish = async (values) => handleSave(values);

    const getOdds = async (loadMore) => {
      if(fetching.current) return;
      if(loadMore) {
        page.current= page.current + 1;
        if(hasMore.current == false){
          return;
        }else{
          fetching.current = true;
        }
      }
      setLoading(true)
      const lastUpdated = showLastUpdates ? "on" : "off"
      // const res = await axios.get(`/api/bet/getBetByDate?startDate=${date.startDate}&endDate=${date.endDate}&leagueId=${selectedLeague}&current=${page}&pageSize=10`)
      const res = await axios.get(`/bet/getOddListByDate?lastUpdated=${lastUpdated}&startDate=${date.startDate}&endDate=${date.endDate}&&leagueId=${selectedLeague}&current=${page.current}&pageSize=300`)
      
      if (res.code != 200) {
        let msg;
        if(res.code == 404) {
          form.setFieldsValue({matches: []})
        }
        setLoading(false)
        setErrorMsg({ code: res.code, msg: res.message})
        setOpenAlert(true)
        return
      }

      const total = res.data.pagination.total;
      const pageSize = res.data.pagination.pageSize;
      const totalPage = Math.ceil(Number(total) / Number(pageSize));

      if(totalPage == page.current) {
        hasMore.current = false;
      }

      let resData = res.data.data;
      let pagination = res.data.pagination;
      setOddsTotal(pagination?.total)
      let arr =[];
      let matchArr = []
      let obj={matches: []};

      const matches = resData;

      matchArr = matches.map(v=> {
        const format = showLastUpdates ?  'h:mm A' : 'DD-MM-YYYY h:mm A' ;
        const time = moment(v.odd[0].match_date).format(format);
      
        return (
        {
          value: v.matchId,
          label: `${v.homeTeam.name_en}-${v.awayTeam.name_en}`,
          label_mm: `${v.homeTeam.name_mm} vs ${v.awayTeam.name_mm}`,
          label_en: `${v.homeTeam.name_en} vs ${v.awayTeam.name_en}`,
          matchTime: time,
          matchStatus: v.status
        }
        )})

      matches.forEach(m=> {
        let hdpFull;let ouFull; let hdpFirst; let ouFirst; let hdpSecond;let ouSecond;
        let homeFTHdp;let home1HHdp;let home2HHdp;
        let typeFT = 'all';let type1H = 'all';let type2H = 'all';
        let maxLimitFT = 0;let maxLimit1H = 0;let maxLimit2H = 0;
        let bodyExtraFT = 0;let bodyExtra1H = 0;let bodyExtra2H = 0;
        let ouExtraFT = 0;let ouExtra1H = 0;let ouExtra2H = 0;
        let popular = false;
        let publishFirst;
        let publishSecond ;
        let publishFull;
        let oddId;
        popular = m.popular == 1 ? true : false;
        if(m.odd){
          m.odd.forEach(o=> {
            if(o.periods == "full_time") {
              publishFull = o.published == 1 ? true : false;
              oddId = o.id;
              hdpFull = o.hdp.converted;
              ouFull = o.ou.converted;
              homeFTHdp = o.hdp.home_team_has_hadicap;
              typeFT = o.type;
              maxLimitFT = o.max_limit_bet_amount;
              bodyExtraFT = `${Number(o.extra.body_extra_amount).toLocaleString()}${o.extra.body_extra_team == "equal" ? "" : o.extra.body_extra_team == "home" ? "(H)" : o.extra.body_extra_team == "away" ? "(A)" : "" }`
              ouExtraFT = `${Number(o.extra.ou_extra_amount).toLocaleString()}${o.extra.body_extra_ou == "equal" ? "" : o.extra.body_extra_ou == "over" ? "(O)" : o.extra.body_extra_ou == "under" ? "(U)" : "" }`
              obj.matches.push({publish: publishFull,oddId,matchId: m.matchId,periods: "full_time",hdp: hdpFull,['o/u']: ouFull,homeTeamHasHandicap: homeFTHdp,popular: popular,betType: typeFT,maxLimit: maxLimitFT,bodyExtra: bodyExtraFT,ouExtra: ouExtraFT})
            }else if(o.periods == "first_time"){
              publishFirst = o.published == 1 ? true : false;
              oddId = o.id;
              hdpFirst = o.hdp.converted;
              ouFirst = o.ou.converted;
              home1HHdp = o.hdp.home_team_has_hadicap;
              type1H = o.type;
              maxLimit1H = o.max_limit_bet_amount;
              bodyExtra1H = `${Number(o.extra.body_extra_amount).toLocaleString()}${o.extra.body_extra_team == "equal" ? "" : o.extra.body_extra_team == "home" ? "(H)" : o.extra.body_extra_team == "away" ? "(A)" : "" }`
              ouExtra1H = `${Number(o.extra.ou_extra_amount).toLocaleString()}${o.extra.body_extra_ou == "equal" ? "" : o.extra.body_extra_ou == "over" ? "(O)" : o.extra.body_extra_ou == "under" ? "(U)" : "" }`
              obj.matches.push({publish: publishFirst,oddId,matchId: m.matchId,periods: "first_time",hdp: hdpFirst,['o/u']: ouFirst,homeTeamHasHandicap: home1HHdp,popular: popular,betType: type1H,maxLimit: maxLimit1H,bodyExtra: bodyExtra1H,ouExtra: ouExtra1H})
            }else{
              publishSecond = o.published == 1 ? true : false;
              oddId = o.id;
              hdpSecond = o.hdp.converted;
              ouSecond = o.ou.converted;
              home2HHdp = o.hdp.home_team_has_hadicap;
              type2H = o.type;
              maxLimit2H = o.max_limit_bet_amount;
              bodyExtra2H = `${Number(o.extra.body_extra_amount).toLocaleString()}${o.extra.body_extra_team == "equal" ? "" : o.extra.body_extra_team == "home" ? "(H)" : o.extra.body_extra_team == "away" ? "(A)" : "" }`
              ouExtra2H = `${Number(o.extra.ou_extra_amount).toLocaleString()}${o.extra.body_extra_ou == "equal" ? "" : o.extra.body_extra_ou == "over" ? "(O)" : o.extra.body_extra_ou == "under" ? "(U)" : "" }`
              obj.matches.push({publish: publishSecond,oddId,matchId: m.matchId,periods: "second_time",hdp: hdpSecond,['o/u']: ouSecond,homeTeamHasHandicap: home2HHdp,popular: popular,betType: type2H,maxLimit: maxLimit2H,bodyExtra: bodyExtra2H,ouExtra: ouExtra2H})
            }
          })
        }
        
      })
      arr.push(obj)
      

      setLoading(false)
      setForceRerender(prevValue => !prevValue);
      if(!loadMore){
        setTimeout(() => {
          
          form.getFieldInstance(['matches',0,'hdp'])?.focus()
        }, 100);
      }

      if(loadMore){
        setMatches(pre => [...pre,...matchArr])
        const orgObj = form.getFieldsValue();
        const combineObj = {matches: [...orgObj.matches,...obj.matches]};
        setStoredData(combineObj)
        form.setFieldsValue(combineObj);
        ogFormData.current = combineObj;
        fetching.current = false;
      }else{
        setMatches(matchArr)
        form.resetFields()
        setStoredData(obj)
        form.setFieldsValue(obj);
        ogFormData.current = obj;
      }
  
    }

    const getLeagues = async () => {
      const data = await axios.get(`/info/getOddLeagueByDate?startDate=${date.startDate}&endDate=${date.endDate}`)
      if(data.code == 404){
        setErrorMsg({ code: data.code, msg: "No leagues found" })
        setOpenAlert(true)
      }
      if(data.code == 200){
        setErrorMsg({ code: data.code, msg: `${data.data.length} leagues found` })
        setOpenAlert(true)
        setLeagues(data.data)
      }
    }

    const handleLeagueBigToggle = async (rowData, checked) => {
      const params = {
        leagueId: rowData.id,
        big: typeof checked === 'boolean' ? (checked === true ? "1" : "0") : rowData.big
      };
      setLoading(true);
      try {
        let res = await axios.put(`/info/updateLeagueById`, params);
        setErrorMsg({ code: res.code, msg: res.message || 'League updated' });
        setOpenAlert(true);
        if (res.code == 200) {
          setLeagues(prev => prev.map(l => l.id === rowData.id ? { ...l, big: params.big } : l));
        }
      } catch (error) {
        setErrorMsg({ code: 500, msg: error?.message || 'Update failed' });
        setOpenAlert(true);
      } finally {
        setLoading(false);
      }
    }

    const handleChangeLang = async (lang) => {
      setLoading(true);
      await new Promise(resolve => setTimeout(resolve,100))
      setMatchLang(lang);
      setForceRerender(prevValue => !prevValue);
      localStorage.setItem('oddLang',JSON.stringify(lang));
      setLoading(false)
    }

    const handleDateChange = (v,dateString) => {
      form.resetFields();
      page.current = 1;
      hasMore.current = true;
      setDate({startDate: `${dateString[0]} 00:00:01`,endDate: `${dateString[1]} 23:59:59`});
    };

    const handleDeleteOdd = async (oddId) =>{
      const res = await axios.delete(`/bet/deleteOddDataByOddId?oddId=${oddId}`);
      setErrorMsg({ code: res.code, msg: res.message })
      setOpenAlert(true);
      getOdds();
    }

    const handlePublish = async (oddId)  => {
      const res = await axios.put(`/bet/updatePublishedByOddId?oddId=${oddId}`);
      if(res.code != 200){
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
      }
    }

    const handleDelete = (oddId) => {
      setSelectedMatchesToDelete(pre => {
        let oddIds = [...pre];
        const found = oddIds.find(o => oddId == o);
        if(found) oddIds = oddIds.filter(o => oddId != o);
        if(!found) oddIds.push(oddId);
        return oddIds;
      })
    }

    const apiCallToDelete = async () =>{
      if(selectedMatchesToDelete.length > 0 ){
        const oddIds = selectedMatchesToDelete.join(',')
        const res = await axios.delete(`/bet/deleteOddDataByOddId?oddId=${oddIds}`)
        if(res.code == 200){
          getOdds();
          setSelectedMatchesToDelete([]);
          return;
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
      }
    }
    const extraClick = (oddId,fieldIndex) => {
      getExtraData(oddId)
      setClickedOddId(oddId);
      setExtraModalOpen(true);
      form.getFieldInstance(['matches', fieldIndex, 'hdp']).focus()
    }
    const parlayClick = (oddId,fieldIndex) => {
      getParlayUser(oddId)
      setClickedOddId(oddId);
      setParlayModalOpen(true);
      form.getFieldInstance(['matches', fieldIndex, 'hdp']).focus()
    }
    const teamClick = (oddId,fieldIndex) => {
      getBetUser(oddId)
      setClickedOddId(oddId);
      setModalOpen(true);
      form.getFieldInstance(['matches', fieldIndex, 'hdp']).focus()
    }
    const getExtraData = async (oddId) => {
      const res = await axios.get(`/bet/getExtraByOddId?oddId=${oddId}`)
      if(res.code == 200 ){
        setBetUsers(res.data);
      }
    }
    const getParlayUser = async (oddId) => {
      const res = await axios.get(`/info/getParlayBetInfoByOddId?oddId=${oddId}`)
      if(res.code == 200 ){
        setBetUsers(res.data);
      }
    }
    const getBetUser = async (oddId) => {
      const res = await axios.get(`/info/getBetInfoByOddId?oddId=${oddId}`)
      if(res.code == 200 ){
        setBetUsers(res.data);
      }
    }

    const handleShowLastUpdates = async (checked) => {
      setLoading(true);
      localStorage.setItem('showLastUpdatesInListOdd',JSON.stringify(showLastUpdates));
      page.current = 1;
      hasMore.current = true;
      setShowLastUpdates(checked);
      if(checked)   setDefaultDate();
    } 

    const handleSelectMatchStatus = (status) => {
      setLoading(true);
      setMatchStatus(status);
      const obj = storedData;
      const matches = obj.matches; 
      let arr = [];
      for (let i = 0; i < matches.length; i++) {
        const match = matches[i];
        if(status == 'all'){
          arr.push(match);
        }
        if(status == 'FT'){
          if(match.periods == 'full_time') arr.push(match);
        }
        if(status == '1H'){
          if(match.periods == 'first_time') arr.push(match);
        }
        if(status == '2H'){
          if(match.periods == 'second_time') arr.push(match);
        }
      }
     const updatedObj = {matches: arr};
     form.setFieldsValue(updatedObj)
     setLoading(false);
    }
     
    const handleRefresh = async () => {
      form.resetFields();
      page.current = 1;
      hasMore.current = true;
      getOdds();
    }

    const handleFormChange = (changedValues, allValues,index) => {
      let changedIndex;
      if(index != null) {
        changedIndex = index
      }else{
        changedIndex = changedValues.matches.length - 1;
      }
      const formData = form.getFieldsValue();
      const changedOdd = {...formData.matches[changedIndex]};
      const foundIndex= changedOdds.current.findIndex(m => m.oddId == changedOdd.oddId);
      if(foundIndex == -1) {
        changedOdds.current.push(changedOdd);
      }else{
        changedOdds.current[foundIndex] = changedOdd;
      }
      
      const ogOdd = ogFormData.current.matches[changedIndex];
      const same = areObjectsEqual(ogOdd,changedOdd);
      if(same) changedOdds.current = changedOdds.current.filter(odd => odd.oddId != changedOdd.oddId);
    }

    function areObjectsEqual(obj1, obj2) {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);
    
      for (let key of keys1) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }
      return true;
    }

    const handleScroll = (event ) => {
      const { clientHeight, scrollHeight, scrollTop} = event.target;
      // console.log("event",clientHeight, scrollHeight, scrollTop)
      if(scrollTop == 0) return
       if (clientHeight + scrollTop >= scrollHeight - 50 ) {
        getOdds(true)
      }
    }

    return (
      <div>
        <div>
            <Space direction="vertical" size={12}>
              { !showLastUpdates &&
               <RangePicker 
                value={date.startDate ? [dayjs(date.startDate.split(/(\s+)/)[0], 'YYYY-MM-DD'), dayjs(date.endDate.split(/(\s+)/)[0], 'YYYY-MM-DD')] : ''}
                onChange={(v,dateString)=> handleDateChange(v,dateString)}
                style={{marginRight: "1rem",marginBottom: "1rem"}}
                />}
            </Space>
            <Select
                // defaultValue={'Ligue 2'}
                value={selectedLeague}
                style={{width: "30%" }}
                onChange={(leagueId)=> {
                  form.resetFields();
                  setSelectedLeague(leagueId);
                  page.current = 1;
                  hasMore.current = true;
                }}
                filterOption={(inputValue, option)=> {
                  const labelText = typeof option.label === 'string' ? option.label : (option.searchText || '');
                  return labelText.toLowerCase().includes(inputValue.toLowerCase());
                }}
                showSearch
                options={[{value: "",label: "All"},...leagues.map(l=> {
                  const checked = l.big === "1" || l.big === 1 || l.big === true;
                  return {
                    value: l.id,
                    searchText: l.value_en,
                    label: (
                      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <span>{l.value_en}</span>
                        <Checkbox
                          checked={checked}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => handleLeagueBigToggle(l, e.target.checked)}
                        />
                      </div>
                    )
                  }
                })]}
                placeholder="Select League"
            />


          <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
          <ModalParlayComponent modalOpen={modalParlayOpen} handleModalClose={handleParlayModalClose} odd={clickedOddId} data={betUsers}/>
          <ModalExtraComponent modalOpen={modalExtraOpen} handleModalClose={handleExtraModalClose} odd={clickedOddId} data={betUsers}/>
          <ModalComponent modalOpen={modalOpen} handleModalClose={handleModalClose} odd={clickedOddId} data={betUsers}/>
          <Spin spinning={loading}>
              <Header handleChangeLang={handleChangeLang} matchLang={matchLang} selectedOddIdsToDelete={selectedMatchesToDelete} apiCallToDelete={apiCallToDelete} showLastUpdates={showLastUpdates} handleShowLastUpdates={handleShowLastUpdates} 
                handleSelectMatchStatus={handleSelectMatchStatus}
                matchStatus={matchStatus}
                handleRefresh={handleRefresh}
              />
              < MemoBody
                handleFormChange={handleFormChange}
                onFinish={onFinish}
                form={form} 
                leagues={leagues}
                saveOddsLoading={saveOddsLoading}
                matches={matches}
                handleSave={handleSave}
                handleSetMatches={handleSetMatches}
                handleOpenAlert={handleOpenAlert}
                matchLang={matchLang}
                oddsTotal={oddsTotal}
                handleScroll={handleScroll}
                handleDeleteOdd={handleDeleteOdd}
                handlePublish={handlePublish}
                handleDelete= {handleDelete}
                teamClick={teamClick}
                forceRerender={forceRerender}
                parlayClick={parlayClick}
                extraClick={extraClick}
              />
              
            </Spin>
        </div>
      </div>
    )
}

const Header = ({handleChangeLang,matchLang,selectedOddIdsToDelete,apiCallToDelete,showLastUpdates,handleShowLastUpdates,matchStatus,handleSelectMatchStatus,handleRefresh}) => {
  const overColor = 'red';
  const underColor = 'green';
  return (
      <div style={{display: 'flex',justifyContent: "end",alignItems: "center"}}>
       {selectedOddIdsToDelete.length > 0 && <Button style={{marginRight: "2rem",backgroundColor: "rgb(221 221 220)"}} type='dashed' onClick={apiCallToDelete}>
            <DeleteIcon style={{color: "red"}}/>
       </Button>}
       <Select
          style={{ width: "8%", margin: "0 1rem 0 0" }}
          size='small'
          value= {matchStatus}
          onChange={(status)=> handleSelectMatchStatus(status)}
          options={[{ value: "all", label: "All" },{ value: "FT", label: "FT" }, { value: "1H", label: "1H" }, { value: "2H", label: "2H" }]}
       />
       <div style={{ color: "black",marginRight: "1.3rem" }}>
          Last Updates
        </div>
        <Switch  checked={showLastUpdates} onChange={(checked)=> handleShowLastUpdates(checked)} style={{marginRight: "1rem"}} />
        <div style={{ color: "black", width: "6%" }}>
          Over <ArrowUpOutlined style={{ color: overColor }} />
        </div>
        <div style={{ color: "black", width: "6%",marginRight: "1.3rem" }}>
         Under <ArrowDownOutlined style={{ color: underColor }} />
        </div>
        <Radio.Group onChange={({target})=>handleChangeLang(target.value)} value={matchLang}>
          <Radio value={'eng'}>Eng</Radio>
          <Radio value={'my'}>Mm</Radio>
        </Radio.Group>
        <Button style={{marginLeft: "2rem",backgroundColor: "rgb(221 221 220)"}} type='dashed' onClick={()=> handleRefresh()}>
            <RefreshOutlinedIcon style={{color: "#673ab7"}}/>
        </Button>
      </div>
  )
}

const Body = ({handleFormChange,teamClick,onFinish,form,handleMatchChange,matches,handleSave,saveOddsLoading,matchLang,oddsTotal,handleScroll,handleDeleteOdd,handlePublish,handleDelete,parlayClick,extraClick}) =>{

   
  return (
    <div>
      <Form
      form={form}
      name="dynamic_form_nest_item"
      style={{
        marginTop: "2rem",
        fontFamily: "inherit",
      }}
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onValuesChange={handleFormChange}
      autoComplete="off"
      css={css`.ant-form-item-explain-error{font-size: 0.8rem}`}
      >

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <th style={{ width: "20px",fontFamily: 'Courgette',color: "darkslategray" }}></th>
          <th style={{ width: "100px",fontFamily: 'Courgette',color: "darkslategray" }}>Time</th>
          <th style={{ width: "70px" ,fontFamily: 'Courgette',color: "darkslategray" }}>HDP</th>
          <th style={{ width: "200px",fontFamily: 'Courgette',color: "darkslategray" }}>Home Team</th>
          <th style={{ width: "200px",fontFamily: 'Courgette',color: "darkslategray" }}>Away Team</th>
          <th style={{ width: "70px" ,fontFamily: 'Courgette',color: "darkslategray" }}>O/U</th>
          {/* <th style={{ width: "100px",fontFamily: 'Courgette',color: "darkslategray" }}>Max Limit</th> */}
          <th style={{ width: "80px" ,fontFamily: 'Courgette',color: "darkslategray" }}>Bet Type</th>
          <th style={{ width: "70px" ,fontFamily: 'Courgette',color: "darkslategray" }}>Publish</th>
          <th style={{ width: "90px" ,fontFamily: 'Courgette',color: "darkslategray" }}>Parlay</th>
          <th style={{ width: "90px" ,fontFamily: 'Courgette',color: "darkslategray" }}>Extra</th>
        </div>
      
        <div
           css={css
            `border-radius: 1rem;
            //  height: 336px; //for 5 matches
            //  overflow-y: scroll;
             padding-top: 1rem;
             margin-top: 1rem;
             box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            `}
            // onScroll={handleScroll}
        >

            <Form.List name="matches">
            {(fields, { add, remove }) => (
            <>
            {fields.map(({ key, name, ...restField }) =>
            {
                return  (
                    <SelectMatchCard
                      key={key}
                      handleMatchChange={handleMatchChange}
                      handleFormChange = {handleFormChange}
                      matches={matches}
                      restField={restField}
                      name={name}
                      remove={remove}
                      form={form}
                      add={add}
                      handleSave={handleSave}
                      teamClick={teamClick}
                      matchLang={matchLang}
                      handleDeleteOdd={handleDeleteOdd}
                      handlePublish={handlePublish}
                      handleDelete = {handleDelete}
                      parlayClick={parlayClick}
                      extraClick={extraClick}
                    />
                )
            }
            )}
            </>
            )}
            </Form.List>
        </div>
        {/* <Pagination  className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={oddsTotal} pageSize={200} showSizeChanger={false} onChange={(page) => handlePageChange(page)} /> */}
        <SaveButton loading={saveOddsLoading} form={form} handleSave={handleSave}/>
      </Form>
    </div>
  )
}

const SelectMatchCard = ({handleFormChange,teamClick,matches,restField,name,form,handleSave,matchLang,handleDeleteOdd,handlePublish,handleDelete,parlayClick,extraClick}) => {
      const fieldNames = ['hdp','homeTeam','awayTeam','o/u','betType','publish'];
      const [deleteLoading,setDeleteLoading] = useState(false);

      const hdpTeamColor = '#ff00c6';
      const nonHdpTeamColor = "blue";
      const overColor = 'red';
      const underColor = 'green';

      const { confirm } = Modal;
      const showConfirm = (fieldIndex) => {
        confirm({
          mask: false,
          centered: true,
          maskClosable: true, 
          title: 'Do you Want delete this odd?',
          icon: <ExclamationCircleFilled />,
          content: '',
          okText: deleteLoading ? <Loader btn={true}/> : "OK",
          onOk() {
            deleteOdd(fieldIndex);
          },
        });
      };

      const handleKeyCode = async (keyName,fieldName,fieldIndex) => {

        if(keyName == 'ArrowRight' || keyName == 'Enter'){
          const index = fieldNames.findIndex((name) => name == fieldName)
          let nextFieldName;
          
          if( keyName == 'Enter' && fieldName == 'hdp'){ // if user clicked 'enter' in 'hdp'
            nextFieldName = fieldNames[index + 3];
          }else if( keyName == 'Enter' && fieldName == 'o/u'){ // if user clicked 'enter' in 'ou'
            if(fieldIndex == (form.getFieldsValue().matches.length - 1)){ // if the match is last 
              return;
            }else{ // if the match is not last 
              fieldIndex = fieldIndex + 1
            }
            nextFieldName = fieldNames[0]
          }else{
            nextFieldName = fieldNames[index + 1];
          }


          if(index == (fieldNames.length - 1)){ // if the field is last in the match
            if(fieldIndex == (form.getFieldsValue().matches.length - 1)){ // if the match is last 
                return;
            }else{ // if the match is not last 
              fieldIndex = fieldIndex + 1
            }
            nextFieldName = fieldNames[0]
          }
          form.getFieldInstance(['matches', fieldIndex, nextFieldName]).focus();
          form.getFieldInstance(['matches', fieldIndex, nextFieldName])?.select();
        }

        if(keyName == 'ArrowLeft'){
          const index = fieldNames.findIndex((name) => name == fieldName)
          let nextFieldName = fieldNames[index - 1];
          if(index == 0){  //if the field is first in the match
            if(fieldIndex == 0) { // if the match is first 
              return;
            }else{// if the match is not first 
              fieldIndex = fieldIndex - 1
            }
            nextFieldName = fieldNames[fieldNames.length - 1]
          }
          form.getFieldInstance(['matches', fieldIndex, nextFieldName]).focus()
        }

        if(keyName == "Control"){
          if(fieldName == 'homeTeam' || fieldName == "awayTeam"){
            const bool = fieldName == 'homeTeam' ? true : false;
            const otherTeamName = bool ? 'awayTeam' : 'homeTeam';
            form.setFieldValue(['matches', fieldIndex, "homeTeamHasHandicap"],bool);
            handleFormChange(null,null,fieldIndex)
            const teamInstance = form.getFieldInstance(['matches', fieldIndex, fieldName]);
            if(teamInstance){
              teamInstance.input.style.backgroundColor  = 'rgb(44 105 103)';
              teamInstance.input.style.color  = 'white';
              // teamInstance.input.style.color  = hdpTeamColor;
              
              const otherTeamInstance = form.getFieldInstance(['matches', fieldIndex, otherTeamName]);
              otherTeamInstance.input.style.backgroundColor  = 'white';
              otherTeamInstance.input.style.color  = 'black';
              // otherTeamInstance.input.style.color  = nonHdpTeamColor;
            }
          }
          if(fieldName == 'publish'){
            const checked = form.getFieldValue(['matches', fieldIndex, fieldName]) ? false : true;
            const {oddId} = form.getFieldValue(['matches', fieldIndex]);
            const obj = form.getFieldsValue();
            const matchId = obj.matches[fieldIndex].matchId ;
            const periods = obj.matches[fieldIndex].periods ;
            obj.matches.forEach((m,matchIndex)=> {
              if(m.matchId == matchId && m.periods == periods){
                form.setFieldValue(['matches', matchIndex, fieldName],checked);
              }
            })
            handlePublish(oddId)
          }
        
        }
        if(keyName == 'CapsLock' || keyName == "s"){
          handleSave(form.getFieldsValue())
        }

        if(keyName == "Delete"){
          showConfirm(fieldIndex);
        }
      }

      const deleteOdd = async (fieldIndex) => {
        setDeleteLoading(true);
        const obj = {...form.getFieldsValue()}
        const newArr = obj.matches.filter((v,index)=> index != fieldIndex)
        const match = obj.matches.filter((v,index)=> index == fieldIndex)[0]
        const oddId = match.oddId
        obj.matches = newArr;
        form.setFieldsValue(obj);
  
        form.getFieldInstance(['matches', fieldIndex - 1,fieldNames[fieldNames.length - 1] ])?.focus();
        await handleDeleteOdd(oddId);
        setDeleteLoading(false)

      }

      const matchIndex = name;
      const selectedMatchId = form.getFieldsValue()?.matches[matchIndex]?.matchId;
      const currentCardMatch = matches.find(m=> m.value == selectedMatchId);
      const periods = form.getFieldValue(['matches', name, 'periods']);
      let {matchTime} = {...currentCardMatch};
      let timeFormat ;
      const possibleFormats = [ 'DD-MM-YYYY h:mm A', 'h:mm A'];
      for (const format of possibleFormats) {    
        if (moment(matchTime, format, true).isValid()) timeFormat = format;
      }
      // if(periods == 'second_time') matchTime = moment(matchTime, timeFormat).add(1, 'hour').format(timeFormat);

      let periodText ;
      if(periods == 'full_time') periodText = "FT*"
      if(periods == 'first_time') periodText = "1H*"
      if(periods == 'second_time') periodText = "2H*"
      const vsLabel = matchLang == 'my' ? currentCardMatch?.label_mm : currentCardMatch?.label_en;
  
      const homeTeam = vsLabel?.split(" vs ")[0]
      const awayTeam = vsLabel?.split(" vs ")[1]

      form.setFieldValue(['matches', name, 'homeTeam'],`${periodText} ${homeTeam}`)
      form.setFieldValue(['matches', name, 'awayTeam'],`${periodText} ${awayTeam}`)

      const home_team_has_hadicap = form.getFieldValue(['matches', name, 'homeTeamHasHandicap']);
      const bodyExtraTeam = form.getFieldValue(['matches', name, 'bodyExtra']).split("(")[1]?.replace(')', '');
      const ouExtraTeam = form.getFieldValue(['matches', name, 'ouExtra']).split("(")[1]?.replace(')', '');
    
      let bodyExtraColor;
 
      if (bodyExtraTeam == "H" && home_team_has_hadicap) {
        bodyExtraColor = hdpTeamColor;
      } else if (bodyExtraTeam == "H" && !home_team_has_hadicap) {
        bodyExtraColor = nonHdpTeamColor;
      } else if (bodyExtraTeam == "A" && !home_team_has_hadicap) {
        bodyExtraColor = hdpTeamColor;
      } else if (bodyExtraTeam == "A" && home_team_has_hadicap) {
        bodyExtraColor = hdpTeamColor;
      } else {
        bodyExtraColor = '';
      }

      let ouExtraColor = (ouExtraTeam == 'O') ? overColor : ( ouExtraTeam == 'U') ? underColor : 'black';


      const validateOddRange = (_, value) => {
        if (value >= 0 && value <= 100) {
          return Promise.resolve();
        }
        return Promise.reject('Odd must be between 0 and 100.');
      };
      const validateMaxLimitRange = (_, value) => {
        if(!value) return Promise.resolve();
        if(/[A-Za-z]/.test(value)){
          const fieldName = _.field.split(".");
          form.setFieldValue(fieldName,value.replace(/[A-Za-z]/g, ''));
          return Promise.resolve();
        }
        if (value >= 0 && value <= 10000000) {
          return Promise.resolve();
        }
        return Promise.reject("0 <=> 10,000,000");
      };

      const validateInputFormat = (_, value) => {
        if(!value) return Promise.resolve();
        const signs = ["+","-","="]
        if(/[A-Za-z]/.test(value)){
          const fieldName = _.field.split(".");
          form.setFieldValue(fieldName,value.replace(/[A-Za-z]/g, ''));
          return Promise.resolve();
        }
        if(signs.includes(value.charAt(0))){
          return Promise.reject( "Invalid Format");
        }  
        const [left, right] = value.split(/[+-]/);   
        if ((left?.length == 2 && left?.charAt(0) == '0') ||  (Number(left) > 50) || (Number(left) < 0 )  || !right || (Number(right) > 100) ) {
          return Promise.reject( "Invalid Format");
        }
        return Promise.resolve();
      };

      const onDeleteClick = () => {
        const fieldIndex = name;
        const {oddId} = form.getFieldValue(['matches', fieldIndex]);
        handleDelete(oddId)
      }

      const {oddId} = form.getFieldValue(['matches', name]);
     return (
      <div style={{display: "flex",justifyContent: "space-around"}}>
        
          <Form.Item name={[name, 'delete']} 
           css={css``}
           wrapperCol={{ span: 24 }}
           {...restField}
           style={{ color: "white", width: "20px",textAlign: 'center' }}
           valuePropName='checked'
         >
            <Checkbox onClick={onDeleteClick}/>
         </Form.Item>
          <div  style={{width: "100px",display: 'flex',flexDirection: "column"}}>
            <span style={{textAlign: "center"}}>{matchTime}</span>
            <span style={{textAlign: "center",color: "rgb(103, 58, 183)"}}>({currentCardMatch?.matchStatus})</span>
          
          </div>
    
         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'hdp']}
           style={{  width: "70px" }}
           rules={[
            { validator: validateInputFormat }
          ]}
         >
           <Input style={{backgroundColor: "#d8d8d8"}} onKeyDown={(e)=> handleKeyCode(e.key,'hdp',name)}/>
         </Form.Item>

         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'homeTeam']}
           style={{ color: "white", width: "200px",}}
         >
           <Input 
           style={{
            backgroundColor: `${home_team_has_hadicap == true && "rgb(44 105 103)"}`,
            color: `${home_team_has_hadicap == true && "white"}`
            // backgroundColor: "#f8f6fe",
            // color: `${home_team_has_hadicap == true ? hdpTeamColor : nonHdpTeamColor}`
          }}
           onKeyDown={(e)=> handleKeyCode(e.key,'homeTeam',name)} type="button" onMouseDown={()=> teamClick(oddId,name)} />
         </Form.Item>


         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'awayTeam']}
           style={{ color: "white", width: "200px"}}
         >
           <Input 
             style={{
              backgroundColor: `${home_team_has_hadicap == false && "rgb(44 105 103)"}`,
              color: `${home_team_has_hadicap == false && "white"}`
              // backgroundColor: "#f8f6fe",
              // color: `${home_team_has_hadicap == false ? hdpTeamColor : nonHdpTeamColor }`
            }}
             onKeyDown={(e)=> handleKeyCode(e.key,'awayTeam',name)} type="button" onMouseDown={()=> teamClick(oddId,name)}/>
         </Form.Item>


         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'o/u']}
           style={{ color: "white", width: "70px" }}
           rules={[
            { validator: validateInputFormat }
          ]}
         >
           <Input style={{backgroundColor: "#d8d8d8"}} onKeyDown={(e)=> handleKeyCode(e.key,'o/u',name)} />
         </Form.Item>
         {/* <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'maxLimit']}
           style={{ color: "white", width: "100px" }}
           rules={[
            { validator: validateMaxLimitRange }
          ]}

         >
           <Input onKeyDown={(e)=> handleKeyCode(e.key,'maxLimit',name)}/>
         </Form.Item> */}

         <Form.Item
           css={css``}
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'betType']}
           style={{ color: "white", width: "80px" }}
         >
           <Select
             style={{ width: "100%", margin: 0 }}
             options={[{ value: "single", label: "single" }, { value: "mix_parlay", label: "Parlay" }, { value: "all", label: "All" }]}
             onKeyDown={(e) => handleKeyCode(e.key, 'betType', name)}
           />
         </Form.Item>
         <Form.Item name={[name, 'publish']} 
           css={css``}
           wrapperCol={{ span: 24 }}
           {...restField}
           style={{ color: "white", width: "70px",textAlign: 'center' }}
           valuePropName='checked'
         >
            <Checkbox onClick={(e)=> handleKeyCode("Control", 'publish', name)} onKeyDown={(e)=> handleKeyCode(e.key, 'publish', name)}/>
         </Form.Item>
          
         {/* <div style={{ color: "white", width: "5%" }}>
           <ArrowUpOutlined style={{color: overColor}}/>
           
         </div>
         <div style={{ color: "white", width: "5%" }}>
            <ArrowDownOutlined style={{color: underColor}}/>
         </div> */}
         <Form.Item
           wrapperCol={{ span: 20 }}
           {...restField}
           name={[name, 'bodyExtra']}
           style={{ width: "90px",justifyContent: "center",
            alignItems: "center",}}
         >
          <ButtonBase
          onClick={()=>parlayClick(oddId,name)}
          component="button"
          style={{
          color: "black",
          display: "flex",
          backgroundColor: "#7BD3EA",
          padding: "0.4rem 1rem",
          borderRadius: "2rem",
          justifyContent: "center",
          alignItems: "center",
          }}
      >
          {<h5 style={{ textAlign: "center", margin: 0 ,color: 'white'}}>View</h5>}
      </ButtonBase>
           {/* <Input type='button' style={{color: bodyExtraColor,backgroundColor: "rgb(251 251 251)"}} onMouseDown={()=> parlayClick(oddId,name)}/> */}
         </Form.Item>
         <Form.Item
           wrapperCol={{ span: 20 }}
           {...restField}
           name={[name, 'ouExtra']}
           style={{ width: "90px",justifyContent: "center",
            alignItems: "center",}}
         >
          <ButtonBase
            onClick={()=>extraClick(oddId,name)}
            component="button"
            style={{
            color: "black",
            display: "flex",
            backgroundColor: "#CC2B52",
            padding: "0.4rem 1rem",
            borderRadius: "2rem",
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            {<h5 style={{ textAlign: "center", margin: 0 ,color: 'white'}}>View</h5>}
        </ButtonBase>
           {/* <Input  type='button' style={{color: ouExtraColor,backgroundColor: "rgb(251 251 251)"}}/> */}
         </Form.Item>
      </div>
     )
}

const SaveButton = ({loading,form,handleSave}) =>{
  return(

   <div
       style={{
       display: "flex",
       justifyContent: "end",
       alignItems: "center",
       padding: "0.6rem 0 0 0",
       marginTop: "1rem",
       }}
   >
          
      <ButtonBase
          onClick={()=>handleSave(form.getFieldsValue())}
          component="button"
          style={{
          color: "black",
          display: "flex",
          backgroundColor: "#408E91",
          padding: "0.6rem 1.8rem",
          borderRadius: "2rem",
          justifyContent: "center",
          alignItems: "center",
          }}
      >
          {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 ,color: 'white'}}>Save</h4>}
      </ButtonBase>
   </div>
  )
}
const ModalExtraComponent = ({modalOpen,handleModalClose,oddId,data}) => {
  return (
    <ModalMui
    aria-labelledby="transition-modal-title"
    aria-describedby="transition-modal-description"
    open={modalOpen}
    onClose={handleModalClose}
    closeAfterTransition
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        timeout: 500,
      },
    }}
  >
    {/* <Fade in={modalOpen} > */}
      <Box sx={style} css={css`padding: 1.4rem 32px;`}>
        <div style={{margin: "0 0 1rem 0",display: 'flex',justifyContent: "space-between",alignItems: "center"}}>
          
          <div>
            <IconButton onClick={()=> handleModalClose()}>
              <ClearIcon/>
            </IconButton>
          </div>
        </div>
        <h3 style={{fontWeight: "bold",color: "black",marginBottom:16}}>{`HDP = ${data.body_extra_amount}(${data.body_extra_team=='home'?'H':'A'})`}</h3>
        <h3 style={{fontWeight: "bold",color: "black"}}>{`O/U   = ${data.ou_extra_amount}(${data.body_extra_ou=='over'?'O':'U'})`}</h3>
      </Box>
    {/* </Fade> */}
  </ModalMui>
  )
}
const ModalParlayComponent = ({modalOpen,handleModalClose,oddId,data}) => {

  const [loading,setLoading] = useState(false);
 

  const columns = [
    {
      title: 'Member Name',
      dataIndex: 'member_name',
      key: 'member_name',
    },
    {
      title: 'Odd',
      dataIndex: 'converted',
      key: 'converted',
    },
    {
      title: 'Selected Team',
      dataIndex: 'selected_team',
      key: 'selected_team',
    },
    {
      title: 'Amount',
      dataIndex: 'bet_amount',
      key: 'bet_amount',
      render: (bet_amount)=> Number(bet_amount).toLocaleString()
    },
  ];
  return (
    <ModalMui
    aria-labelledby="transition-modal-title"
    aria-describedby="transition-modal-description"
    open={modalOpen}
    onClose={handleModalClose}
    closeAfterTransition
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        timeout: 500,
      },
    }}
  >
    {/* <Fade in={modalOpen} > */}
      <Box sx={style} css={css`padding: 1.4rem 32px;`}>
        <div style={{margin: "0 0 1rem 0",display: 'flex',justifyContent: "space-between",alignItems: "center"}}>
          
          <div>
            <IconButton onClick={()=> handleModalClose()}>
              <ClearIcon/>
            </IconButton>
          </div>
        </div>
      <Table
        columns={columns}
        loading={loading}
        dataSource={data['ou']}
        pagination={false}
      />
       
      </Box>
    {/* </Fade> */}
  </ModalMui>
  )
}
const ModalComponent = ({modalOpen,handleModalClose,oddId,data}) => {

  const [loading,setLoading] = useState(false);
  const [type,setType] = useState('hdp');
  
  const handleChangeType = (type) => {
    setType(type)
  }

  const columns = [
    {
      title: 'Member Name',
      dataIndex: 'member_name',
      key: 'member_name',
    },
    {
      title: 'Odd',
      dataIndex: 'converted',
      key: 'converted',
    },
    {
      title: 'Selected Team',
      dataIndex: 'selected_team',
      key: 'selected_team',
    },
    {
      title: 'Amount',
      dataIndex: 'bet_amount',
      key: 'bet_amount',
      render: (bet_amount)=> Number(bet_amount).toLocaleString()
    },
  ];
  return (
    <ModalMui
    aria-labelledby="transition-modal-title"
    aria-describedby="transition-modal-description"
    open={modalOpen}
    onClose={handleModalClose}
    closeAfterTransition
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        timeout: 500,
      },
    }}
  >
    {/* <Fade in={modalOpen} > */}
      <Box sx={style} css={css`padding: 1.4rem 32px;`}>
        <div style={{margin: "0 0 1rem 0",display: 'flex',justifyContent: "space-between",alignItems: "center"}}>
          <Radio.Group onChange={({target})=>handleChangeType(target.value)} value={type} >
            <Radio value={'hdp'}>Body</Radio>
            <Radio value={'ou'}>O/U</Radio>
          </Radio.Group>
          <div>
            <IconButton onClick={()=> handleModalClose()}>
              <ClearIcon/>
            </IconButton>
          </div>
        </div>
      <Table
        columns={columns}
        loading={loading}
        dataSource={data[type]}
        pagination={false}
      />
       
      </Box>
    {/* </Fade> */}
  </ModalMui>
  )
}
const arePropsEqual = (oldProps,newProps) => {
  const arePropsEqual =  oldProps.forceRerender == newProps.forceRerender  ;
  return arePropsEqual;
}

const MemoBody = memo(Body,arePropsEqual);